import React, { useContext, useEffect, useState } from "react";
import translate from "../i18n/Translator";
import DialogPopup from "../components/DialogPopup";
import { Button, Grid } from "@material-ui/core";
import { AppContext } from "../context/AppContext";
import { ErrorSnackbar } from "../components/Snackbars";
import { Cfdi, ReplacePaymentCfdiRequest, PAYMENT_FORM } from "../model/Cfdi";
import { replaceCfdi } from "../api/CfdiAPI";
import ValidatedInput, { InputRef } from "../components/ValidatedInput";
import DatePicker from "../components/DatePicker";
import moment from "moment";

interface ReplaceCfdiPopupProps {
    cfdi: Cfdi;
    onClose(): any;
    onSuccess(cfdi: Cfdi): any;
}

export default function ReplaceCfdiPopup(props: ReplaceCfdiPopupProps) {
    const context = useContext(AppContext);
    const paymentFormLabels = PAYMENT_FORM.map(form => translate(`payment_form.${form}`) as string);
    const paymentForm = props.cfdi.complementos?.pagos?.pagos[0].forma_pago;
    const paymentDate = moment(props.cfdi.complementos?.pagos?.pagos[0].fecha_pago || new Date()).format("YYYY-MM-DD");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState<string>();
    const [request, setRequest] = useState<ReplacePaymentCfdiRequest>({
        form: "",
        date: new Date()
    } as ReplacePaymentCfdiRequest);
    const [validations, setValidations] = useState<any>({} as any);

    useEffect(() => {
        const pagos = props.cfdi.complementos?.pagos?.pagos;
        if (pagos && pagos.length > 0) {
            const pago = pagos[0];
            if (PAYMENT_FORM.indexOf(pago.forma_pago) >= 0) {
                setRequest({ ...request, form: pago.forma_pago, date: pago.fecha_pago });
            } else {
                setRequest({ ...request, date: pago.fecha_pago });
            }
        }
        // eslint-disable-next-line
    }, [props.cfdi]);

    const hasChanged = (name: string, value: string, inputRef: InputRef) => {
        console.log(name, value);
        setRequest({ ...request, [name]: value });
        validations[name] = inputRef;
        setValidations(validations);
    };

    const onChangedDate = (name: string, raw?: string, date?: Date) => {
        if (date) {
            setRequest({ ...request, date: date })
        } else {
            setRequest({ ...request, date: new Date() })
        }
    };

    const isValid = () => {
        var valid = true;
        for (let field in validations) {
            let ref = validations[field];
            if (!ref.valid) {
                ref.blurer(true);
                valid = false;
            }
        }
        return valid;
    }

    const onConfirm = () => {
        if (!isValid()) return;

        setSubmitting(true);
        replaceCfdi(context.session!.tenant!.id, props.cfdi.id, request).then((cfdi) => {
            props.onSuccess(cfdi);
        }).catch(error => {
            setSubmitting(false);
            setError(error.message);
        });
    };

    return (
        <DialogPopup open title={translate("cfdis.replace.title")} maxWidth="sm"
            disableEscapeKeyDown={submitting}
            disableBackdropClick={submitting}
            disable={submitting}
            onClose={props.onClose}
            closeColor="default"
            closeText={translate("buttons.close") as string}
            button={context.isGranted("CfdisDelete") ?
                <Button onClick={onConfirm} variant="outlined" color="secondary" disabled={submitting || (paymentForm === request.form && paymentDate === moment(request.date).format("YYYY-MM-DD"))}>
                    {translate("buttons.confirm")}
                </Button>
                : undefined}>
            <Grid container justify="space-between" alignItems="center" spacing={2}>
                <Grid item xs={12}>
                    {translate("cfdis.replace.text")}
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12} className="DatePicker">
                            <DatePicker label={translate("payments.register.date") as string}
                                name="date" initial={request.date ? moment(request.date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")}
                                onChange={onChangedDate}
                                defaultIfMissing={false} clearable={false} autoOK disableFuture />
                        </Grid>
                        <Grid item xs={12}>
                            <ValidatedInput type="text" id="form" name="form"
                                value={request.form} label={translate("payments.form.title") as string}
                                required={true} disabled={submitting}
                                options={PAYMENT_FORM} optionLabels={paymentFormLabels}
                                margin="dense"
                                onValueChanged={hasChanged} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <ErrorSnackbar message={error} onClose={() => setError(undefined)} />
        </DialogPopup>
    );

}